import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Select, Cascader, Table, Input } from "antd";
import { fetchQuestions, setKeyValue, resetSearchStatus, fetchInterviewAreas } from "./actions";
import { fetchQuestionYears } from "../QuestionList/actions";
import { fetchResource } from "../InterviewCategory/actions";
import { checkPermission } from '../../utils/utils';
import { fetchTag } from "../EssayCategory/actions";
import './index.scss';

const Option = Select.Option;

class InterviewList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        this.fetchInterviewHandler();
        this.props.dispatch(fetchQuestionYears());
        this.props.dispatch(fetchInterviewAreas());
        this.props.dispatch(fetchResource());
        this.props.dispatch(fetchTag());
    }

    /** 加载申论题目的handler */
    fetchInterviewHandler = () => {
        let obj = {};
        obj.page = this.props.page || 1;
        obj.pageSize = this.props.pageSize || 10;
        let keys = ['province', 'query', 'questionTag', 'title', 'year'];
        keys.map(key => { this.props[key] && (obj[key] = this.props[key]); })
        obj = this.checkCategoryId(obj);
        this.props.dispatch(fetchQuestions(obj));
    }

    checkCategoryId = obj => {
        let categoryId = this.props.categoryId;
        if (Object.prototype.toString.call(categoryId) !== '[object Array]') return obj;
        for (let id of categoryId) {
            if (id) obj.categoryId = id;
        }
        return obj;
    }

    handleSelect = async eventKey => {
        await this.props.dispatch(setKeyValue('page', eventKey));
        this.fetchInterviewHandler();
    };

    selectProvince = async value => {
        await this.props.dispatch(setKeyValue('province', value));
        await this.props.dispatch(setKeyValue('page', 1));
        this.fetchInterviewHandler();
    };

    selectTag = async value => {
        await this.props.dispatch(setKeyValue('questionTag', value));
        await this.props.dispatch(setKeyValue('page', 1));
        this.fetchInterviewHandler();
    }

    selectYear = async value => {
        await this.props.dispatch(setKeyValue('year', value));
        await this.props.dispatch(setKeyValue('page', 1));
        this.fetchInterviewHandler();
    };

    handleInput = value => { this.props.dispatch(setKeyValue('title', value)); };

    handleQuery = value => { this.props.dispatch(setKeyValue('query', value)); }

    handleSearch = () => {
        this.props.dispatch(setKeyValue('page', 1));
        this.fetchInterviewHandler();
    }

    resetSearch = async () => {
        await this.props.dispatch(resetSearchStatus());
        this.fetchInterviewHandler();
    }

    /** 改变分页大小的时候触发 */
    onShowSizeChange = async (current, size) => {
        await this.props.dispatch(setKeyValue('page', 1));
        await this.props.dispatch(setKeyValue('pageSize', size));
        this.fetchInterviewHandler();
    }

    sourceHandler = (arr) => {
        if (!arr.length) return [];
        if(arr[0].name=='全部') return arr;
        let defaultItem = { id: '', name: '全部', subset: []};
        arr.map((item) => {
            if(item.subset && item.subset.length) {
                this.sourceHandler(item.subset);
            }
        });
        arr.unshift(defaultItem);
        return arr;
    }

    changeCategoryId = async value => {
        await this.props.dispatch(setKeyValue('categoryId', value));
        this.fetchInterviewHandler();
    }

    generateTableColumns = () => {
        let columns = [
            {
                title: '标题',
                with: '40%',
                render: (text, record) => checkPermission('sys:view:gkinfo') && <Link to={`/interviewInfo/${record.id}`}>{record.title}</Link> || <span>{record.title}</span>
            },
            { title: '地区', with: '30%', dataIndex: 'area' },
            { title: '年份', with: '30%', dataIndex: 'year' },
        ];
        return columns;
    }

    /** 生成antd table的表头数据 */
    renderHeader = () => (
        <div className="commonTableTitle">
            试题列表
            {checkPermission('sys:view:edit') && 
                <Button type="primary">
                    <Link to={`/interviewRelease`}>
                        添加试题
                </Link>
                </Button>
            }
        </div>
    )

    render() {
        let columns = this.generateTableColumns();
        let resource = this.sourceHandler(this.props.resource);
        return (
            <div className="interviewListContainer">
                {checkPermission('sys:view:page') && <div className="commonSearchBox">
                <div>
                    <label>年份</label>
                    <Select
                        value={this.props.year + ""}
                        className="commonW150"
                        dropdownMatchSelectWidth={false}
                        onChange={value => { this.selectYear(value) }}
                    >
                        <Option value="">全部</Option>
                        {this.props.years && this.props.years.map((year, idx) => {
                            return <Option key={idx} value={year + ""}>{year}年</Option>
                        })}
                    </Select>
                </div>
                <div>
                    <label>地区</label>
                    <Select
                        value={this.props.province}
                        className="commonW150"
                        dropdownMatchSelectWidth={false}
                        onChange={value => { this.selectProvince(value) }}>
                        <Option value="">全部</Option>
                        {this.props.areas.map((province, idx) => {
                            return <Option key={idx} value={province}>{province}</Option>
                        })}
                    </Select>
                </div>

                <div>
                    <label>标签</label>
                    <Select
                        value={this.props.questionTag}
                        className="commonW150"
                        dropdownMatchSelectWidth={false}
                        onChange={value => { this.selectTag(value) }}>
                        <Option value="">全部</Option>
                        {this.props.tags.map((tag, idx) => {
                            return <Option key={idx} value={tag.value}>{tag.desc}</Option>
                        })}
                    </Select>
                </div>

                <div>
                    <label>题型分类</label>
                    <Cascader
                        className="commonW400"
                        fieldNames={{ label: 'name', value: 'id', children: 'subset' }}
                        value={this.props.categoryId}
                        options={resource}
                        changeOnSelect
                        showSearch
                        onChange={value=>this.changeCategoryId(value)}
                    />
                </div>
                <div>
                    <label>试题查询</label>
                    <Input
                        className="commonW400"
                        placeholder="输入试题标题查询"
                        value={this.props.title}
                        onChange={e => this.handleInput(e.target.value)}
                        onPressEnter={() => this.handleSearch()} 
                    />
                </div>
                <div>
                    <label>问题查询</label>
                    <Input
                        className="commonW400"
                        placeholder="输入问题关键词查询"
                        value={this.props.query}
                        onChange={e => this.handleQuery(e.target.value)}
                        onPressEnter={() => this.handleSearch()} 
                    />
                </div>
                <div>
                    <Button disabled={this.props.isFetching} type="primary" onClick={this.handleSearch}>搜索</Button>
                </div>
                <div>
                    <Button disabled={this.props.isFetching} type="danger" onClick={this.resetSearch}>重置</Button>
                </div>
                </div>}
                <Table
                    columns={columns}
                    dataSource={this.props.items}
                    rowKey={record => record.id}
                    title={this.renderHeader}
                    loading={this.props.isFetching}
                    pagination={{
                        showSizeChanger: true,
                        pageSize: this.props.pageSize,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        onShowSizeChange: this.onShowSizeChange,
                        current: this.props.page,
                        total: this.props.totalElements,
                        showTotal: total => `共有${total}条数据`,
                        onChange: this.handleSelect,
                        showQuickJumper: true,
                    }}
                />
            </div>
        )
    }

}

function mapStatetoProps(state) {
    const { years } = state.questions;

    const { resource } = state.interviewCategory;

    const { tags } = state.essayCategory;

    return {
        years,
        resource,
        tags,
        ...state.interviewList
    };
}

export default connect(mapStatetoProps)(InterviewList);
